<ng-container *transloco="let t">
  <p-dialog
    [dismissableMask]="false"
    [draggable]="false"
    [(visible)]="display"
    styleClass="notification-dialog"
    appendTo="body"
    [maximizable]="(type$ | async) === 'server'"
    (onHide)="closeErrorDialog()"
  >
    <ng-template pTemplate="header">
      <span class="p-dialog-title">{{ title$ | async }}</span>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="error-content">
        <i class="dialog-icon {{ icon$ | async }} fa-3x fa-pull-left"></i>

        <div class="error-pre-text">
          {{ t('core.components.notifications.error_pre_text') }}
        </div>

        <div class="error-post-text">
          {{ t('core.components.notifications.error_post_text') }}
        </div>

        <p-divider>
          <span class="error-line-heading">{{ t('core.components.notifications.labels.message') }}</span>
        </p-divider>

        <div class="error-text error-text-technical">{{ message$ | async }}</div>

        <p-divider>
          <span class="error-line-heading">{{ t('core.components.notifications.labels.details') }}</span>
        </p-divider>

        <div class="error-technical-details">
          <div class="grid">
            <div class="label col">{{ t('core.components.notifications.labels.timestamp') }}</div>
            <div class="value col">{{ timestamp$ | async | date : 'MM/dd/yyyy HH:mm:ss zzzz' }}</div>
          </div>

          <div class="grid">
            <div class="label col">{{ t('core.components.notifications.labels.url') }}</div>
            <div class="value col">{{ url$ | async }} {{ statusCode$ | async }}</div>
          </div>

          <div class="grid">
            <div class="label col">{{ t('core.components.notifications.labels.request_id') }}</div>
            <div class="value col">{{ requestId$ | async }}</div>
          </div>

          <div class="grid">
            <div class="label col">{{ t('core.components.notifications.labels.code') }}</div>
            <div class="value col">{{ errorCode$ | async }}</div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <z-toast key="main"></z-toast>
  <z-confirm-dialog></z-confirm-dialog>
</ng-container>
